// extracted by mini-css-extract-plugin
export default {"mainWarning":"styles_mainWarning__0y2Jk","containerWarning":"styles_containerWarning__oGx7F","context":"styles_context__YuYKZ"};